import { configureStore } from "@reduxjs/toolkit";
import counterSlice from "./reducers/counterSlice";
import SuggestionQuestionSlice, {
  initialState,
} from "./reducers/SuggestionQuestionSlice";
// import sagaMiddleware from "redux-saga";
import SearchQuestionSlice from "./reducers/SearchQuestionSlice";
import questionSlice from "./reducers/questionSlice";
import PlaylistSlice from "./reducers/PlaylistSlice";
import SearchPlaylistSlice from "./reducers/SearchPlaylistSlice";

// import RootSaga from "./saga/RootSaga";

// const saga = sagaMiddleware();
/**
 * --------------------------------------------------
 * Redux Store
 * --------------------------------------------------
 * This is the central Redux store for the application.
 * All slices (state modules) are combined here.
 * 
 * Each slice manages its own piece of the state:
 * - suggestion → Suggested questions & tag data
 * - question → Single question state
 * - search → Question search results
 * - playlist → Playlist data
 * - playlistSearch → Playlist search results
 *
 * Note:
 * Some slices use createAsyncThunk + extraReducers for async API calls,
 * while others (like suggestion) use manual reducers to manage loading/error states.
 */

export const store = configureStore({
  reducer: {
    suggestion: SuggestionQuestionSlice,
    question: questionSlice,
    search: SearchQuestionSlice,
    playlist: PlaylistSlice,
    playlistSearch: SearchPlaylistSlice,
  },
  /**
   * Middleware configuration
   * -----------------------
   * RTK uses redux-thunk by default for async actions.
   * We also configure serializableCheck:
   * - Redux requires state/actions to be serializable (no class instances, functions, etc.)
   * - API responses often contain nested objects or dates that can trigger warnings
   * - We ignore certain paths and actions to avoid unnecessary warnings
   */
  // middleware: [saga],
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['question/getquestion/fulfilled', 'search/postSearch/fulfilled', 'playlistData/PlaylistFetch/fulfilled', 'playlists/ViewPlaylist/fulfilled'],
        // , 'playlist/PlaylistFetch/fulfilled'
        // Ignore these field paths in all actions
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['question.question.0', 'search.search.0', 'playlist.playlistData.0', 'playlist.playlists.0'],
      },
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = ReturnType<typeof store.dispatch>;
